// @flow

// WEB ROUTES
/*
The version component of this is temporary until
we can update all of the Facebook urls to get rid of the /B
*/
export const jobApplicationRouteUnversioned = (jobHash: ?string) => `/apply/${jobHash || ':jobHash'}`;
export const jobApplicationRoute = (jobHash: ?string) => `/apply/${jobHash || ':jobHash'}/:version?`;
export const jobApplicationRouteVersioned = (jobHash: ?string, version: ?string) => `/apply/${jobHash || ':jobHash'}/v/${version || ':version'}`;
export const wizardPageRoute = (jobApplicationHash: ?string) => `/wizard/${jobApplicationHash || ':jobApplicationHash'}`;
export const referralIntakeRoute = (employeeHash: ?string) => `/refer/${employeeHash || ':employeeHash'}`;
export const referralApplyRoute = (jobHash: ?string, referralHash: ?string) => `/apply/${jobHash || ':jobHash'}/referral/${referralHash || ':referralHash'}`;
export const PRIVACY_POLICY_ROUTE = '/privacypolicy';
